import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const Svg2D = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "m 22 1 h -19 a 2 2 0 0 0 -2 2 v 18 a 2 2 0 0 0 2 2 h 19 a 2 2 0 0 0 2 -2 v -18 a 2 2 0 0 0 -2 -2 m -19 2 h 19 v 18 h -19 z m 2 3 v 2 h 4 v 3 h -2 a 2 2 0 0 0 -2 2 v 3 a 2 2 0 0 0 2 2 h 4 v -2 h -4 v -3 h 2 a 2 2 0 0 0 2 -2 v -3 a 2 2 0 0 0 -2 -2 z m 8 0 h 2 c 4 0 5 3 5 6 c 0 3 -1 6 -5 6 h -2 z m 2 2 v 8 c 2 0 3 -2 3 -4 c 0 -2 -1 -4 -3 -4" })]
});
export default Svg2D;
